// init
export const INIT_REQUEST = 'INIT_REQUEST';
export const INIT_SUCCESS = 'INIT_SUCCESS';
export const INIT_FAILURE = 'INIT_FAILURE';

export const HYDRATE_ENCOUNTER_AUDIT_REASONS = 'HYDRATE_ENCOUNTER_AUDIT_REASONS';
